var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanquetHall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7915 22.5209L12.7787 27.0017C13.3878 27.9153 14.2247 28.6542 15.2068 29.1452V29.1452C16.0646 29.5741 15.9476 30.8334 15.0255 31.0969L6.89554 33.4197C5.51233 33.8149 4.18935 32.6338 4.42585 31.2148L5.87484 22.5209",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.489583,
    y: 0.489583,
    width: 6.85417,
    height: 0.979167,
    rx: 0.489583,
    transform: "matrix(-1 0 0 1 42.1038 39.1666)",
    stroke: "#1C1C1C",
    strokeWidth: 0.979167
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.489583,
    y: 0.489583,
    width: 6.85417,
    height: 0.979167,
    rx: 0.489583,
    transform: "matrix(-1 0 0 1 10.7708 39.1666)",
    stroke: "#1C1C1C",
    strokeWidth: 0.979167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1665 33.2916V39.1666",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83301 33.2916V39.1666",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.208 22.5209L34.2208 27.0017C33.6117 27.9153 32.7748 28.6542 31.7927 29.1452V29.1452C30.9349 29.5741 31.0519 30.8334 31.9741 31.0969L40.104 33.4197C41.4872 33.8149 42.8102 32.6338 42.5737 31.2148L41.1247 22.5209",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1982 25.2459C20.2978 24.7979 20.6952 24.4792 21.1541 24.4792H25.8456C26.3045 24.4792 26.7019 24.7979 26.8014 25.2459L29.8477 38.9543C29.9836 39.5658 29.5183 40.1458 28.8919 40.1458H18.1078C17.4814 40.1458 17.0161 39.5658 17.1519 38.9543L20.1982 25.2459Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.604 15.6666V15.6666C21.4663 17.9564 25.5334 17.9564 28.3957 15.6666V15.6666",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9165 14.6033V18.6042C3.9165 20.7673 5.67006 22.5208 7.83317 22.5208H8.80658C10.704 22.5208 12.5369 21.8321 13.9649 20.5827L17.1052 17.8349C18.734 16.4097 20.0022 14.619 20.806 12.6095L22.4256 8.56064C22.9401 7.27428 21.9928 5.875 20.6073 5.875H13.8533C11.8332 5.875 9.84811 6.40218 8.09419 7.40442C5.51082 8.88063 3.9165 11.6279 3.9165 14.6033Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.083 14.6033V18.6042C43.083 20.7673 41.3295 22.5208 39.1663 22.5208H38.1929C36.2955 22.5208 34.4626 21.8321 33.0346 20.5827L29.8943 17.8349C28.2655 16.4097 26.9973 14.619 26.1935 12.6095L24.5739 8.56064C24.0594 7.27428 25.0067 5.875 26.3922 5.875H33.1462C35.1663 5.875 37.1514 6.40218 38.9053 7.40442C41.4887 8.88063 43.083 11.6279 43.083 14.6033Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanquetHall);
export default __webpack_public_path__ + "static/media/banquet_hall.bdf18feebe3439be08d28f1a5055eb22.svg";
export { ForwardRef as ReactComponent };